module.exports = "/_next/static/images/ScoreMeter3@2x-3f591cecba5bfd12ed9eb7aa321e9b93.png";